const docMissingEmployeeStatus = {
  text: 'COLABORADOR BLOQUEADA MANUALMENTE'
};

export default docMissingEmployeeStatus;
